import { render, staticRenderFns } from "./Products.Vue?vue&type=template&id=0b3899bb"
import script from "./Products.Vue?vue&type=script&lang=js"
export * from "./Products.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Products.Vue
// module id = 184
// module chunks = 0